import { useFormikContext } from "formik";
import {
  DatePickerField,
  DisplayFormErrors,
  InputField,
  VerticalForm,
} from "melco-shared-logic";
import { Space } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import { DisplayProductsDropDown } from "../../dropdown/DisplayProductsDropDown";
import { useRefferalDropDownData } from "../../../hooks/dropdown/useRefferalDropDownData";
import { useState } from "react";
import { DisplayLevelSubscriptionDropDown } from "../../dropdown/DisplayLevelSubscriptionDropDown";
import { DisplayRefferalDropDown } from "../../dropdown/DisplayRefferalDropDown";
import { DisplayBlankDropDown } from "../../dropdown/DisplayBlankDropDown";
import { VIRTUAL_SECURITY_TYPE } from "../../../helper/licenseHelper";
import { useRolesContext } from "../../../hooks/roles/useRolesContext";
import { GenerateLicenseConfirmButton } from "../GenerateLicenseConfirmButton";
import { DisplayProductVersionsDropDown } from "../../dropdown/DisplayProductVersionsDropDown";
import { useAllProducts } from "../../../hooks/useAllProduts";
import dayjs from "dayjs";

const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 50px;
`;

type DisplayGenerateLicenseFormProps = {
  referenceDrawer?: DrawerType;
};

export const DisplayGenerateLicenseForm: React.FC<
  DisplayGenerateLicenseFormProps
> = ({ referenceDrawer }) => {
  const { t } = useTranslation();
  const { values } = useFormikContext();

  const [selectedProductValue, setSelectedProductValue] = useState("");
  const [selectedVersionValue, setSelectedVersionValue] = useState("");

  const [productIsSubscription, setProductIsSubscription] = useState(false);
  const [generateConfirmDetailsToDisplay, setGenerateConfirmDetailsToDisplay] =
    useState({
      product_code_label: "",
      subscription_code_label: "",
      referral_code_label: "",
      version_number_label: "",
      subscription_start_date: undefined as Date | undefined,
    });
  const responseRefferal = useRefferalDropDownData();
  const allProducts = useAllProducts();

  const { roles } = useRolesContext();
  const { setFieldValue } = useFormikContext();
  let generateAccessFilterListArray =
    roles?.VIRTUAL_SECURITY_GENERATE_ACCESS_LIST_FILTER_LIST?.toString()?.split(
      ","
    ) ?? [];
  generateAccessFilterListArray.map((value) => value.trim());

  const products = allProducts?.products.filter((p) => {
    if (
      roles.VIRTUAL_SECURITY_GENERATE_ACCESS_LIST &&
      roles.VIRTUAL_SECURITY_GENERATE_ACCESS_LIST_FILTER_LIST &&
      roles.VIRTUAL_SECURITY_GENERATE_ACCESS_LIST_FILTER_LIST !== ""
    ) {
      if (p.code) {
        return (
          p.security_type === VIRTUAL_SECURITY_TYPE &&
          generateAccessFilterListArray.includes(p.code)
        );
      }
    } else {
      return p.security_type === VIRTUAL_SECURITY_TYPE;
    }
  });

  const callBackForSubscription = (v: any, subscription: any) => {
    setGenerateConfirmDetailsToDisplay({
      ...generateConfirmDetailsToDisplay,
      subscription_code_label: subscription.label,
    });
  };

  const callBackForProduct = (v: string, product: any) => {
    console.log(
      "PRODUCT SELECTED ",
      JSON.stringify(product.product.is_subscription)
    );
    setSelectedProductValue(v);
    setGenerateConfirmDetailsToDisplay({
      ...generateConfirmDetailsToDisplay,
      product_code_label: product.label,
    });
    setProductIsSubscription(product.product.is_subscription);
    setFieldValue("subscription_start_date", null);
  };

  const callBackForVersion = (v: any) => {
    /**
     * We have to use dropdown label as version value
     * because the api products/subscriptions takes version_number_list as a version number
     * This is version object  
     * {
            "id": "PVR-1",
            "version_number": "12",
            "created_date": "2023-11-07T19:51:55.04Z"
        }

        While Generate new License we have to use id like PVR-1
        While we have to search for subscriptions (Level)  we have to use 12

        
          */
    setSelectedVersionValue(v.label);
    setGenerateConfirmDetailsToDisplay({
      ...generateConfirmDetailsToDisplay,
      version_number_label: v.label,
    });
  };

  const callBackForRefferal = (v: string, refferal: any) => {
    setGenerateConfirmDetailsToDisplay({
      ...generateConfirmDetailsToDisplay,
      referral_code_label: refferal.label,
    });
  };

  // const handleDateChange = (date: Dayjs | null) => {
  //   if (date) setSelectedDate(date);
  //   console.log("Selected date:", date?.format("YYYY-MM-DD"));
  // };

  return (
    <>
      <div>
        <Right direction="vertical" size="small">
          <GenerateLicenseConfirmButton
            GenerateConfirmDetailsToDisplay={generateConfirmDetailsToDisplay}
            GenerateConfirmDetails={values}
            referencesDrawer={referenceDrawer}
          //openAskConirmationBoxTrigger={openAskConirmationBoxTrigger}
          //onCloseDrawer={onCloseDrawer}
          ></GenerateLicenseConfirmButton>
        </Right>

        <VerticalForm>
          <DisplayFormErrors />

          <DisplayProductsDropDown
            defaultProducts={{
              list: products,
              total: allProducts.products.length,
            }}
            callbackFn={callBackForProduct}
          />

          {selectedProductValue ? (
            <DisplayProductVersionsDropDown
              selectedProductValue={selectedProductValue}
              callbackFn={callBackForVersion}
            />
          ) : (
            <DisplayBlankDropDown
              name="version_id"
              label={t("licenses.basic.detail.generate.version")}
            />
          )}

          {selectedProductValue && selectedVersionValue ? (
            <DisplayLevelSubscriptionDropDown
              selectedProductValue={selectedProductValue}
              selectedVersionValue={selectedVersionValue}
              callbackFn={callBackForSubscription}
            />
          ) : (
            <DisplayBlankDropDown
              name="subscription_code"
              label={t("licenses.basic.search.level.title")}
            />
          )}
          {productIsSubscription ? (
            <DatePickerField
              label={t(
                "licenses.basic.detail.generate.subscription_start_date"
              )}
              name="subscription_start_date"
              disabledDate={(current) =>
                !!current && current.isBefore(dayjs().startOf("day"))
              }
            />
          ) : null}
          <DisplayRefferalDropDown
            defaultRefferals={{
              list:
                responseRefferal &&
                  responseRefferal.data &&
                  responseRefferal.data.list
                  ? responseRefferal.data.list
                  : [],
              total:
                responseRefferal &&
                  responseRefferal.data &&
                  responseRefferal.data?.total
                  ? responseRefferal.data.total
                  : 0,
            }}
            callbackFn={callBackForRefferal}
          />

          <InputField
            name="serial_number"
            label={t("licenses.basic.detail.generate.how_many")}
          />
        </VerticalForm>
      </div>
    </>
  );
};
